import { serverError } from '@/locales/pt-br/errors'

export default {
  routeTitle: 'Listagem de Planos',
  title: 'Wordpress',
  subtitle: 'Nossas boas vindas, <b>{name}</b>',
  headerAction: 'Contratar novo plano',
  description: 'Aqui você pode configurar seus planos de Wordpress.',
  plan: {
    adminSites: 'Administrar sites',
    name: {
      hosting_wordpress_1: 'Hospedagem WP I',
      hosting_wordpress_2: 'Hospedagem WP II',
      hosting_wordpress_3: 'Hospedagem WP III',
      hosting_wordpress_starter: 'Hospedagem WP Starter',
      hosting_wordpress_performance: 'Hospedagem WP Performance',
      hosting_wordpress_pro: 'Hospedagem WP Pro'
    },
    usage: 'Sites: {consumed} de {limit}',
    status: {
      active: 'Ativo',
      activating: 'Instalando',
      deactivated: 'Inativo',
      deleting: 'Deletando'
    }
  },
  result: {
    error: serverError,
    empty: {
      title: 'Nenhum plano encontrado',
      description: 'Verificamos que ainda não possui nenhum plano de wordpress; para prosseguir contrate um plano.',
      action: 'Contratar Hospedagem Wordpress'
    },
    supportPanel: {
      action: 'Acessar painel de sustentação do Wordpress'
    }
  }
}
